export const CRON_EXPRESSION_MODE = 'CRON_EXPRESSION_MODE';
export const FREQUENCY_BASED_MODE = 'FREQUENCY_BASED_MODE';
